import { __assign } from '../../../external/tslib/tslib.es6.mjs.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { PolicyIcon } from '../../../icons/PolicyIcon.js';
import policyStyles from './Policy.module.scss.js';

var Policy = function (_a) {
    var name = _a.name, products = _a.products, className = _a.className, style = _a.style;
    return (jsxs("div", __assign({ className: clsx(policyStyles.policy, className), style: style }, { children: [jsx(PolicyIcon, { className: policyStyles.policyIcon }), jsxs("div", __assign({ className: policyStyles.policyContent }, { children: [name, jsxs("span", { children: [products[0], " ", products.length > 1 && "+".concat(products.length - 1)] })] }))] })));
};

export { Policy };
